import { Component } from '../../../utils/modules';
import "./synLoader.sass"
class SynLoader extends Component {
    render() { 
        return (
          <section className="synLoader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </section>
            
        );
    }
}
 
export default SynLoader;